export default __webpack_public_path__ + "static/media/gif.b4005d14.gif";